import React, { useEffect, useState } from 'react';
import CustomModal from './CustomModal';
import './TagSelectedModal.css';

const TagSelectedModal = ({ tagSelectedModalOpen, closeModal, handleTagSelectedSubmit }) => { 
    const [tags, setTags] = useState("");

    const handleTagsChange = (e) => {
        setTags(e.target.value);
    };

    useEffect(() => {
        if (tagSelectedModalOpen) {
            setTags("");
        }
    }, [tagSelectedModalOpen]);

    return (
        <CustomModal
        isOpen={tagSelectedModalOpen}
        onRequestClose={closeModal}
        overlayClassName="modal-overlay"
        modalClassName="modal-base"
        headerContent={<h3>Add Tags</h3>}
        bodyContent={
            <div></div>
        }
        footerContent={
            <div className="modal-footer-content">
            <div className="footer-tags-container">
              <label>Add Tags (Comma Separated):</label>
              <input
                type="text"
                value={tags}
                onChange={handleTagsChange}
              />
            </div>
            <div className="footer-buttons">
              <button onClick={() => handleTagSelectedSubmit(tags)}>Submit</button>
              <button onClick={closeModal}>Close</button>
            </div>
          </div>
        }     
        />
    );
};

export default TagSelectedModal;
